window.dataLayer = window.dataLayer || [];

class WaitlistForm extends HTMLElement {
  constructor() {
    super();

    // Trigger and Popup elements
    this.button = this.querySelector('.waitlist-trigger-button');
    this.closeBtn = this.querySelector('.waitlist__popup-close');
    this.popup = this.querySelector('.waitlist__popup');

    // Countdown Timer elements
    this.timerContainer = this.querySelector('.countdown-timer');
    this.hoursDisplay = this.querySelector('#timer-hours');
    this.minutesDisplay = this.querySelector('#timer-minutes');
    this.secondsDisplay = this.querySelector('#timer-seconds');
    this.countdownInterval = null;

    // Password Validation elements
    this.passwordInput = this.querySelector('#timer__popup-password');
    this.submitBtn = this.querySelector('.timer__popup button');
    this.messageDisplay = this.querySelector('.timer__popup-message');

    // Dynamic Session key based on Product ID
    const productId = this.dataset.productId || 'default';
    this.sessionKey = `waitlist_unlocked_${productId}`;

    // States
    this.alreadyClicked = false;
    this.delay = parseInt(this.getAttribute('data-delay'));

    if(this.delay) {
      this.delay = this.delay.toFixed(0);
    }

    if (!this.button || !this.popup) return;

    this.init();

    // Check if this specific product has been unlocked in this session
    this.checkExistingSession();

    if (this.timerContainer) {
      this.initTimer();
    }

    if (this.submitBtn && this.passwordInput) {
      this.initPasswordCheck();
    }
  }

  // Check if the specific product key exists in sessionStorage
  checkExistingSession() {
    if (sessionStorage.getItem(this.sessionKey) === 'true') {
      this.unlockContent();
    }
  }

  // Logic to activate success state and show Add to Cart
  unlockContent() {
    document.body.classList.add('is--waitlist-success');

    // Show success message if display element exists
    if (this.messageDisplay) {
      const msgSuccess = this.dataset.successMessage;
      const colorSuccess = this.dataset.successColor;
      this.messageDisplay.style.display = 'block';
      this.messageDisplay.innerText = msgSuccess;
      this.messageDisplay.style.color = colorSuccess;
    }
  }

  init() {
    this.button.addEventListener('click', () => this.togglePopup(true));

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.togglePopup(false));
    }

    this.popup.addEventListener('click', (e) => {
      if (e.target === this.popup) {
        this.togglePopup(false);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('show-waitlist-popup')) {
        this.togglePopup(false);
      }
    });
  }

  initTimer() {
    const startStr = this.timerContainer.dataset.start;
    const endStr = this.timerContainer.dataset.deadline;

    const parseETDate = (dateStr) => {
      if (!dateStr) return NaN;
      const normalizedStr = dateStr.trim().replace(' ', 'T');
      const date = new Date(normalizedStr);
      if (isNaN(date.getTime())) return NaN;

      const nyString = date.toLocaleString('en-US', { timeZone: 'America/New_York' });
      const nyDate = new Date(nyString);
      const diff = date.getTime() - nyDate.getTime();
      const finalTimestamp = date.getTime() + diff;

      return finalTimestamp;
    };

    const startDate = parseETDate(startStr);
    const endDate = parseETDate(endStr);

    const update = () => {
      const now = new Date().getTime();

      if (now < startDate) {
        document.body.classList.add('is-timer-not-started');
        this.renderTime(0, 0, 0);
        return;
      }

      if (now >= endDate) {
        if (this.countdownInterval) clearInterval(this.countdownInterval);
        document.body.classList.add('is--timer-finished');
        this.renderTime(0, 0, 0);
        return;
      }

      document.body.classList.add('is-timer-active');
      document.body.classList.remove('is-timer-not-started');

      const timeLeft = endDate - now;

      const hours = Math.floor(timeLeft / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      this.renderTime(hours, minutes, seconds);
    };

    update();
    this.countdownInterval = setInterval(update, 1000);
  }

  initPasswordCheck() {
    this.submitBtn.addEventListener('click', () => {
      window.dataLayer.push({
        'event': 'ea_password_attempt',
        'event_category': 'Early Access'
      });

      const value = this.passwordInput.value.trim().toLowerCase();
      const correctPassword = String(window.waitlistPassword).toLowerCase();

      const msgEmpty = this.dataset.emptyMessage;
      const msgError = this.dataset.errorMessage;
      const colorInvalid = this.dataset.invalidColor;

      if (!this.messageDisplay) return;

      if (value === "") {
        this.messageDisplay.style.display = 'block';
        this.messageDisplay.innerText = msgEmpty;
        this.messageDisplay.style.color = colorInvalid;
      } else if (value !== correctPassword) {
        this.messageDisplay.style.display = 'block';
        this.messageDisplay.innerText = msgError;
        this.messageDisplay.style.color = colorInvalid;
      } else {
        // Success: Store specific product ID in session and unlock
        sessionStorage.setItem(this.sessionKey, 'true');
        this.unlockContent();
        setTimeout(() => {
          if (this.closeBtn) {
            this.closeBtn.click();
            window.dataLayer.push({
              'event': 'ea_password_success',
              'event_category': 'Early Access',
              'product_id': window.localProductId
            });
          }
        }, 1500);
      }
    });
  }

  renderTime(h, m, s) {
    if (this.hoursDisplay) {
      this.hoursDisplay.innerText = h.toString().padStart(2, '0');
    }

    if (this.minutesDisplay) {
      this.minutesDisplay.innerText = m.toString().padStart(2, '0');
    }

    if (this.secondsDisplay) {
      this.secondsDisplay.innerText = s.toString().padStart(2, '0');
    }

    if (!this.alreadyClicked) {
      this.alreadyClicked = true;

      const button = this.button;
      let attempts = 0;
      const maxAttempts = 50;

      const interval = setInterval(() => {
        const form = document.querySelector('.c-klaviyo-form-wrap form');

        if (form) {
          if (window.getComputedStyle(button).getPropertyValue('display') !== 'none') {
            if (sessionStorage.getItem(`is_form_applied_${window.localProductId}`) != 'true') {
              setTimeout(() => {
                button.click();
              }, this.delay);
            }
          }
          clearInterval(interval);
        }

        if (++attempts > maxAttempts) {
          clearInterval(interval);
        }
      }, 400);

      if (document.body.classList.contains('is-timer-active')) {
        this.button.innerText = this.getAttribute('data-early-access-cta-text');
      }
    }
  }

  togglePopup(force) {
    document.body.classList.toggle('show-waitlist-popup', force);
    document.body.classList.toggle('overflow', force);

    // If not unlocked yet, reset input and hide messages on close
    if (sessionStorage.getItem(this.sessionKey) !== 'true') {
      if (this.messageDisplay) this.messageDisplay.style.display = 'none';
      if (this.passwordInput) this.passwordInput.value = '';
    }

    if(document.body.classList.contains('is-timer-active') && document.body.classList.contains('show-waitlist-popup')) {
      window.dataLayer.push({
        'event': 'ea_cta_click',
        'event_category': 'Early Access',
        'event_label': 'Shop Early Access Click'
      });
    }
  }

  disconnectedCallback() {
    if (this.countdownInterval) clearInterval(this.countdownInterval);
  }
}

if (!customElements.get('waitlist-form')) {
  customElements.define('waitlist-form', WaitlistForm);
}

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == 'submit') {

    if (e.detail.formId == 'Tnm2yd' || e.detail.formId == 'Yn6PzP' || e.detail.formId == 'T3faFA' || e.detail.formId == 'TeDhQx' || e.detail.formId == 'RmTTcM') {
      setTimeout(() => {
        const inputEmail = document.querySelector('.c-klaviyo-form-wrap input[type="email"]');
        const inputPhone = document.querySelector('.c-klaviyo-form-wrap input[type="tel"]');

         if(!inputEmail && inputPhone) {
          document.body.classList.add('is--waitlist-second-step');
        } else {
          document.body.classList.remove('is--waitlist-second-step');
        }
      }, 350);

      setTimeout(() => {
        const waitlistPopupClose = document.querySelector('.waitlist__popup-close');
        const inputEmail = document.querySelector('.c-klaviyo-form-wrap input[type="email"]');
        const inputPhone = document.querySelector('.c-klaviyo-form-wrap input[type="tel"]');
        if (!inputEmail && !inputPhone && waitlistPopupClose) {
          waitlistPopupClose.click();
          sessionStorage.setItem(`is_form_applied_${window.localProductId}`, 'true');

          document.body.classList.add('is--waitlist-form-applied');
        }
      }, 1800);
    }
  }
});

// document.body.classList.add('is--waitlist-second-step');